export const SNIFF_SETTINGS = '/me/sniff-settings'
export const SNIFF_DISTANCE = '/pets'
